(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InfectionPrimaryAccessDetailController', InfectionPrimaryAccessDetailController);

    InfectionPrimaryAccessDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InfectionPrimaryAccess', 'Infection', 'Corporation'];

    function InfectionPrimaryAccessDetailController($scope, $rootScope, $stateParams, previousState, entity, InfectionPrimaryAccess, Infection, Corporation) {
        var vm = this;

        vm.infectionPrimaryAccess = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:infectionPrimaryAccessUpdate', function(event, result) {
            vm.infectionPrimaryAccess = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
